import { Identity } from "@schibsted/account-sdk-browser";
import { productInfoDeferred } from "./Actions";
import getIdentity from "./getIdentity";

function loadIdentity(): Promise<Identity> {
  return new Promise<Identity>((resolve, reject) => {
    productInfoDeferred.promise
      .then(productInfo => resolve(getIdentity(productInfo.owningClient)))
      .catch(reject);
  });
}

export default loadIdentity;
